import { render } from "./AssetGroupsView.vue?vue&type=template&id=142447d8&scoped=true&ts=true"
import script from "./AssetGroupsView.vue?vue&type=script&lang=ts"
export * from "./AssetGroupsView.vue?vue&type=script&lang=ts"

import "./AssetGroupsView.vue?vue&type=style&index=0&id=142447d8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142447d8"]])

export default __exports__